"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFilteredDatePrograms = void 0;
var lodash_1 = require("lodash");
var utils_1 = require("@shapeable/utils");
var useFilteredDatePrograms = function (programs) {
  var isProgramCurrent = function (program) {
    return program.courses.some(function (course) {
      return (0, utils_1.isDatePast)(course.startDate) && (0, utils_1.isDateFuture)(course.endDate);
    });
  };
  var isProgramUpcoming = function (program) {
    return !isProgramCurrent(program) && program.courses.some(function (course) {
      return (0, utils_1.isDateFuture)(course.startDate);
    });
  };
  // Sort by the earliest course start date
  var getEarliestCourseStartDate = function (program) {
    var validStartDates = program.courses.map(function (course) {
      return new Date(course.startDate).getTime();
    }).filter(function (timestamp) {
      return !isNaN(timestamp);
    }); // Exclude invalid dates
    return Math.min.apply(Math, __spreadArray([], __read(validStartDates), false));
  };
  var currentPrograms = (0, lodash_1.sortBy)(programs.filter(isProgramCurrent), getEarliestCourseStartDate);
  var upcomingPrograms = (0, lodash_1.sortBy)(programs.filter(isProgramUpcoming), getEarliestCourseStartDate);
  return {
    currentPrograms: currentPrograms,
    upcomingPrograms: upcomingPrograms
  };
};
exports.useFilteredDatePrograms = useFilteredDatePrograms;